export default "__VITE_ASSET__BfwV50L6__"